module.exports = "/_next/static/images/DiagnoseDataQualityIssues-3d6b05dc4626cb17070c2afef851c66e.webp";